const euroFormat = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
});

export const formatCurrency = (euro: number): string => euroFormat.format(euro);

export const formatCurrencyFromCents = (cents: number): string =>
  formatCurrency(cents / 100);
